// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1tDQa","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1uMBB","obliqueLine":"membershipbadge_obliqueLine__36nEh"};